import React from 'react';
import { Alert } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const ErrorMessage = ({ message, description, type = 'error', showIcon = true, closable = true }) => {
  return (
    <Alert
      message={message}
      description={description}
      type={type}
      showIcon={showIcon}
      icon={<ExclamationCircleOutlined />}
      closable={closable}
      style={{ 
        marginBottom: '16px',
        borderRadius: '8px',
        border: '1px solid #ff4d4f',
        backgroundColor: '#fff2f0'
      }}
    />
  );
};

export default ErrorMessage;